import React, { useState } from "react";
import jeep from "../../assets/Mahindra-Thar 1.png";
import { Link } from "react-router-dom";

const questions = [
  {
    id: 1,
    head: "What types of cars are available?",
    question:
      "We offer a wide range of cars, including sedans, SUVs, hatchbacks, and luxury vehicles. Both new and pre-owned options are available.",
  },
  {
    id: 2,
    head: "Do you provide financing options?",
    question:
      "Yes, we offer flexible financing options tailored to suit your budget and needs. Contact us for more details.",
  },
  {
    id: 3,
    head: "Can I trade in my old car?",
    question:
      "Absolutely! We accept trade-ins. Get your car evaluated by our team to find out its trade-in value.",
  },
  {
    id: 4,
    head: "How do I schedule a test drive?",
    question:
      "You can schedule a test drive by filling out the form on our website or contacting our sales team directly.",
  },
  // {
  //   id: 5,
  //   head: "Are the cars listed covered by warranty?",
  //   question: "Yes, most of the cars listed on our website come with a warranty. Details vary by vehicle and will be mentioned in the description.",
  // },
  // {
  //   id: 6,
  //   head: "What documents are required to purchase a car?",
  //   question: "You will need a valid ID, proof of insurance, and proof of income for financing. Additional documents may be required depending on your location.",
  // },
  // {
  //   id: 7,
  //   head: "Do you offer roadside assistance?",
  //   question: "Yes, we provide optional roadside assistance services. You can choose to add this to your purchase or rental package.",
  // },
  // {
  //   id: 8,
  //   head: "What is your return or cancellation policy?",
  //   question: "Our return and cancellation policies vary based on the type of transaction. Please refer to the specific terms and conditions or contact our support team.",
  // },
  // {
  //   id: 9,
  //   head: "Can I view car reviews on your website?",
  //   question: "Yes, we provide detailed reviews and ratings for most cars listed on our website to help you make informed decisions.",
  // },
  // {
  //   id: 10,
  //   head: "Do you offer insurance with car purchases or rentals?",
  //   question: "Yes, we offer optional insurance coverage for both car purchases and rentals. Contact our team to explore the available plans.",
  // },
];

const Questions = () => {
  const [openId, setOpenId] = useState(null);

  const toggleAccordion = (id) => {
    setOpenId((prevId) => (prevId === id ? null : id));
  };

  return (
    <>
      <div
        className="leading-normal gap-6 flex flex-col items-center py-6 self-stretch"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        <div className="flex justify-center items-center w-4/5">
          <h4
            className="font-normal text-xl sm:text-3xl text-black leading-normal"
            style={{ fontFamily: "Ballega" }}
          >
            Frequently asked Questions
          </h4>
        </div>
        <p className="text-black text-base text-center font-normal leading-normal w-4/5">
          "Have questions? We’ve got answers! Whether you’re buying, selling, or
          exploring finance options, our comprehensive FAQs are designed to
          guide you through every step of the process. Get clarity on the most
          common queries and feel confident about making informed decisions with
          us."
        </p>
        <div className="w-11/12">
          {questions.map((faq) => (
            <div key={faq.id} className="mb-4">
              <div
                className="flex flex-col justify-between items-start w-full px-4 py-2 text-left text-black bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer"
                onClick={() => toggleAccordion(faq.id)}
              >
                <div className="flex justify-between items-center w-full">
                  <h4 className="font-bold text-lg">{faq.head}</h4>
                  <span className="p-2">
                    {openId === faq.id ? (
                      <svg
                        className="w-6 h-6 text-black"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          d="M6 18L18 6M6 6l12 12"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-6 h-6 text-black"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 5v14m7-7H5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </span>
                </div>
                {openId === faq.id && (
                  <div className="mt-2 text-black text-base text-start font-normal leading-normal">
                    {faq.question}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="relative w-11/12 bg-sky-600 text-white sm:mt-24 sm:h-96 xl:h-full flex flex-col sm:flex-row items-center">
          <img src={jeep} alt="jeep" className="sm:w-2/3 lg:mt-[-120px]" />
          <div
            className="text-center sm:text-end xl:pr-14 sm:pt-20 xl:mr-12 p-4"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            <h4
              className="text-3xl sm:text-4xl xl:text-5xl leading-tight"
              style={{ fontFamily: "Ballega" }}
            >
              "Upgrade Your Ride <span className="inline sm:block">Today!</span>
            </h4>
            <p className="text-base py-6">
              "Special Offers on Buying and Selling Cars in Hyderabad – Limited
              Time Only!"
            </p>
            <Link
              to="/contact"
              className="bg-white text-black text-lg font-bold p-1 sm:p-2"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Questions;
